import type { Segment } from '$shared/models/Segment';

class SegmentData {
  private segments: Segment[] = [];

  public get hasMultipleSegments(): boolean {
    return this.segments.length > 1;
  }

  public get defaultSegment(): Segment | undefined {
    return this.segments.find((segment) => segment.isDefault);
  }

  public setSegments(segments: Segment[]): void {
    this.segments = segments;
  }

  public getSegmentsAsCommonList(): CommonList[] {
    return this.segments.map((segment) => segment.toCommonList());
  }

  public getSegmentById(id: string): Segment | undefined {
    return this.segments.find((segment) => segment.id === id);
  }

  public reset(): void {
    this.segments = [];
  }
}

export const segmentData = new SegmentData();
